import axios from 'axios';
import tools from '@/tools';
import store from '@/store/index';
import sendErrorToSlack from "../constants/app/slackErrorhandler";

const prodUrl = "https://api.myeduquiz.com/api/v0.0.1/";
const devUrl = "http://localhost:4000/api/v0.0.1/";
const testUrl = "https://test-dot-uesquizmaker-api.ey.r.appspot.com/api/v0.0.1/";
// const digitalOceanServer = "http://142.93.166.47:4000/api/v0.0.1/";


const currentBaseUrl = process.env.NODE_ENV === 'production' ? prodUrl : process.env.NODE_ENV === 'test' ? testUrl : devUrl;

// Retry mekanizması için gerekli ayarlar
const maxRetries = 2;  // Maksimum tekrar sayısı
const retryDelay = 10000; // 10 saniye bekleme süresi (ms)

const instance = axios.create({
  baseURL: testUrl,
  timeout: 90000,  // 90 saniye timeout
});

// İstek interceptor'ı
instance.interceptors.request.use((config) => {
  const token = tools.cookie.get('authToken');
  config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Yanıt interceptor'ı
instance.interceptors.response.use(res => res.data, async (err) => {
  const statusCode = err.response ? err.response.status : null;
  const config = err.config;

  if (!config) {
    return Promise.reject(err);
  }

  // Eğer daha önce retry yapılmadıysa, config'e retry sayısını ekle
  if (!config.retryCount) {
    config.retryCount = 0;
  }

  // 401 hatası durumunda kullanıcıyı logout yap
  if (statusCode === 401) {
    await store.dispatch("user/logout");
    window.location.reload();
    return Promise.reject(err);
  }

  // Belirtilen max retry sayısına ulaşılmadıysa ve istek tekrarlanabilirse
  if (config.retryCount < maxRetries) {
    config.retryCount += 1;  // Retry sayısını artır
    console.warn(`Retrying request (${config.retryCount}/${maxRetries}) in ${retryDelay / 1000} seconds...`);

    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(instance(config));
      }, retryDelay);
    });
  }

  // Slack'e hata mesajı gönder (tüm retry'ler başarısızsa)
  const errorMessage = `HTTP Error: ${config.url} - Status ${statusCode} - Retries: ${config.retryCount}`;
  sendErrorToSlack(errorMessage);

  return Promise.reject(err);
});

export default () => instance;
